(() => {
  const COOKIE_NAME = 'lensza_promotion_popup_seen';
  const DEFAULT_COOKIE_LIFETIME = 7;
  const DEFAULT_DELAY = 3;

  function initializePromotionPopup() {
    const promotion = document.querySelector('[data-dialog-promotion]');
    const dialogModal = document.getElementById('DialogModal');
    const template = promotion?.querySelector('template');

    if (
      !promotion ||
      !dialogModal ||
      !template ||
      typeof dialogModal.setContent !== 'function' ||
      typeof dialogModal.openModal !== 'function'
    ) {
      return;
    }

    const isDesignMode = promotion.dataset.designMode === 'true';
    const isCookieDisabled = promotion.dataset.cookieDisabled === 'true';
    const cookieName = promotion.dataset.cookieName || COOKIE_NAME;
    const parsedLifetime = Number.parseFloat(promotion.dataset.cookieLifetime);
    const cookieLifetime = Number.isFinite(parsedLifetime) && parsedLifetime > 0
      ? parsedLifetime
      : DEFAULT_COOKIE_LIFETIME;
    const parsedDelay = Number.parseFloat(promotion.dataset.delay);
    const delay = Number.isFinite(parsedDelay) && parsedDelay >= 0
      ? parsedDelay
      : DEFAULT_DELAY;

    if (!isDesignMode && !isCookieDisabled && window.wakaCookie?.get(cookieName)) {
      return;
    }

    window.setTimeout(() => {
      if (typeof dialogModal.setSize === 'function') {
        dialogModal.setSize('medium');
      }

      dialogModal.setContent(template.innerHTML);
      dialogModal.openModal();

      if (!isDesignMode && !isCookieDisabled && typeof window.wakaCookie?.set === 'function') {
        window.wakaCookie.set(cookieName, 'shown', cookieLifetime);
      }
    }, delay * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePromotionPopup, { once: true });
  } else {
    initializePromotionPopup();
  }
})();
